<template>
	<DashboardItem :header="$t('dashboard.signalStats.headers.top')" :timing="$t('dashboard.generalTiming')">
		<Row>
			<Col :span="24">
				<VerticalLayout>
					<Row :gutter="[16, 0]">
						<Col :span="12">
							<SubNetworkSelect ref="subNetworkSelect" :onChange="refresh" />
						</Col>
						<Col :span="12">
							<VerticalLayout>
								<span>{{ $t('dashboard.signalStats.labels.metric') }}</span>
								<Select class="width-100" v-model:value="selectedMetric" :options="metricOptions" />
							</VerticalLayout>
						</Col>
					</Row>
					<VrsSignalsStatsOverview :vrsSignalsStats="vrsSignalsStats" :vrsSelectedSignals="vrsSelectedSignals" :selectedMetric="selectedMetric" />
				</VerticalLayout>
			</Col>
		</Row>
	</DashboardItem>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { Col, Row, Select } from 'ant-design-vue';

import Api from '@/api/Api';

import { useI18n } from 'vue-i18n';

import { showErrorMessage } from '@/components/common/errorMessage';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import SubNetworkSelect from '@/components/common/controls/SubNetworkSelect.vue';
import DashboardItem from '@/components/dashboard/DashboardItem.vue';

import VrsSignalsStatsOverview from '@/components/dashboard/signalStats/VrsSignalsStatsOverview.vue';

export default {
	components: {
		Row, Col, Select, VrsSignalsStatsOverview, SubNetworkSelect, DashboardItem, VerticalLayout,
	},
	setup(props, {expose}) {
		const { t } = useI18n();
		const vrsSignalsStats = ref([]);
		const vrsSelectedSignals = ref([]);
		const subNetworkSelect = ref();
		const refresh = () => {
			if (subNetworkSelect.value.selectedId == null) {
				return;
			}
			Api.subNetworkVrsSignalsStatsGet(subNetworkSelect.value.selectedId, response => {
				if (response.status === 'ok') {
					vrsSignalsStats.value = response.vrsSignalsStats;
					vrsSelectedSignals.value = response.vrsActiveSignals || [];
				} else {
					showErrorMessage(response.errors);
				}
			});
		};
		const safeSubNetworkSelectedId = computed(() => subNetworkSelect.value != null ? subNetworkSelect.value.selectedId : null);
		watch(safeSubNetworkSelectedId, () => {
			refresh();
		});

		const selectedMetric = ref('signals_count');
		const metricOptions = computed(() => [
			{ value: 'signals_count', label: t('dashboard.signalStats.labels.signals_count') },
			{ value: 'mountpoints_count', label: t('dashboard.signalStats.labels.mountpoints_count') },
		]);

		expose({ refresh });
		return {
			vrsSignalsStats,
			vrsSelectedSignals,
			subNetworkSelect,
			selectedMetric,
			metricOptions,
			refresh,
		};
	},
}
</script>
